import dayjs from 'dayjs';

// 메시지 타입 한글 매핑
export const messageTypeLabels = {
    certificate: '인증서 알림톡',
    review: '후기 알림톡',
    friend: '친구톡'
};

// 숫자 포맷팅 - 천 단위 콤마
export const formatNumber = (value) => {
    if (value === null || value === undefined || value === 0) return '0';
    if (typeof value !== 'number') return value;
    return value.toLocaleString('ko-KR');
};

// 퍼센트 포맷팅 - 소수점 2자리
export const formatPercentage = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value !== 'number') return value;
    return `${value.toFixed(2)}%`;
};

// 요일 한글 매핑
const dayOfWeekKorean = ['일', '월', '화', '수', '목', '금', '토'];

// 날짜 포맷팅 - M/D(요일) 형식
export const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = dayjs(dateStr);
    if (!date.isValid()) return dateStr;
    const dayOfWeek = dayOfWeekKorean[date.day()];
    return `${date.format('M/D')}(${dayOfWeek})`;
};

// 요일 가져오기 (0: 일요일, 6: 토요일)
export const getDayOfWeek = (dateStr) => {
    if (!dateStr) return null;
    const date = dayjs(dateStr);
    if (!date.isValid()) return null;
    return date.day();
};

// 날짜 포맷팅 - YYYY-MM-DD 형식
export const formatDateFull = (dateStr) => {
    if (!dateStr) return '-';
    const date = dayjs(dateStr);
    if (!date.isValid()) return dateStr;
    return date.format('YYYY-MM-DD');
};

// 메시지 타입별 빈 값 처리
export const shouldShowDash = (messageType, field) => {
    // friend 타입: 후기작성수, 공유수는 항상 "-"
    if (messageType === 'friend' && (field === 'reviewSubmissions' || field === 'shares')) {
        return true;
    }
    // certificate, review 타입: 퀴즈참여수는 항상 "-"
    if ((messageType === 'certificate' || messageType === 'review') && field === 'quizParticipants') {
        return true;
    }
    return false;
};

// 값 표시 (빈 값 처리 포함)
export const displayValue = (value, messageType, field) => {
    if (shouldShowDash(messageType, field)) {
        return '-';
    }
    if (value === null || value === undefined || value === 0) {
        return '-';
    }
    return formatNumber(value);
};

// 가중평균 계산
export const calculateWeightedAverage = (items, valueField, weightField) => {
    if (!items || items.length === 0) return 0;

    const totalWeight = items.reduce((sum, item) => sum + (item[weightField] || 0), 0);
    if (totalWeight === 0) return 0;

    const weightedSum = items.reduce((sum, item) => {
        const value = item[valueField] || 0;
        const weight = item[weightField] || 0;
        return sum + (value * weight);
    }, 0);

    return weightedSum / totalWeight;
};

// 메시지 타입 정렬 순서
export const messageTypeOrder = {
    certificate: 1,
    review: 2,
    friend: 3
};

// 메시지 타입별 정렬
export const sortByMessageType = (a, b) => {
    const orderA = messageTypeOrder[a.messageType] || 999;
    const orderB = messageTypeOrder[b.messageType] || 999;
    return orderA - orderB;
};

// 클릭수 포맷팅 - uniqueClicks(clicks) 형식
export const formatClicks = (uniqueClicks, clicks) => {
    // 둘 다 0이면 "0"만 표시
    if ((uniqueClicks === 0 || uniqueClicks === null || uniqueClicks === undefined) &&
        (clicks === 0 || clicks === null || clicks === undefined)) {
        return '0';
    }

    const uniqueValue = uniqueClicks || 0;
    const totalValue = clicks || 0;

    return `${uniqueValue.toLocaleString('ko-KR')}(${totalValue.toLocaleString('ko-KR')})`;
};
